import { defineMessages } from 'react-intl';

import { INTENDED_USE } from '@ratehub/documents/mtg-journey-document/stable';


export default defineMessages({
    [INTENDED_USE.OWNER_OCCUPIED]: {
        id: 'Mortgages.intendedUsage.ownerOccupied',
        defaultMessage: 'Owner-occupied',
    },
    [INTENDED_USE.RENTAL]: {
        id: 'Mortgages.intendedUsage.rental',
        defaultMessage: 'Rental',
    },
    [INTENDED_USE.SECOND_HOME]: {
        id: 'Mortgages.intendedUsage.secondHome',
        defaultMessage: 'Second home',
    },
    [INTENDED_USE.OWNER_OCCUPIED_RENTAL]: {
        id: 'Mortgages.intendedUsage.ownerOccupiedAndRental',
        defaultMessage: 'Owner-occupied and rental',
    },
});
